// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b15d423","453":"84ef072c","455":"8da25f57"}[chunkId] + ".chunk.js";
};